(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.resultreport', indexController);

    indexController.$inject = ["modules.goals.service", "$q", "bizUser", "$stateParams", "$filter", "mobiEvent", "$mdToast"];

    function indexController(goalService, $q, bizUser, $stateParams, $filter, event, $mdToast) {
        var vm = this

        vm.PeriodTypes = ['Week', 'Month'];        
        vm.PeriodType = vm.PeriodTypes[0]
        vm.PeriodDayBreak = 5;

        vm.labels = ["Framsteg", "Kvar"];
        vm.colors = ["#0079EA", "#65AEF2"];
        vm.options = { cutoutPercentage: 75 };
        vm.data = [0, 100];
        vm.userData = [0, 100];
        vm.UserProgressSum = {};
        vm.UserProgressSum.ProgressValue = 0;
        vm.ToolTipDateFormat = "DD MMM";
        vm.RootGoals = [];
        vm.Goals = [];

        vm.CommentCount = 0;

        vm.UserId = ~~$stateParams.userid;
        if (vm.UserId <= 0) {
            vm.UserId = bizUser.getLoggedInUser().Id;
        }      

        vm.PeriodCommentSettings = {
            NewCommentData: {
                PreventReplies: true
            }
        };

        vm.NextPeriodCommentSettings = {
            PreventReplies: true,
            HideDate: true
        };
        
        vm.CurrentDate = BizPartCoreHelpers.getDateNow();
        vm.SelectedPeriod = goalService.GetSelectedPeriod();

        //not used anymore?
        //vm.IsFirstWeekInQuarter = goalService.GetIsFirstWeekInQuarter(vm.CurrentDate);

        vm.PeriodLengthInDays = 7;

        vm.TasksInPeriod = [];
        vm.TasksInPreviousPeriod = [];

        vm.LoadTasks = LoadTasks;                
        //vm.GetCurrentProgress = GetCurrentProgress;
        //vm.GetProgressPeriodCompare = GetProgressPeriodCompare;
        vm.GetTodoCount = GetTodoCount;
        //vm.PopulateProgressChart = PopulateProgressChart;  
        //vm.GetUserProgressSum = GetUserProgressSum;      
        //vm.IsExpired = IsExpired;
        vm.GetGoalAndActivityComments = GetGoalAndActivityComments;
        vm.GetGoals = GetGoals;
        vm.lblFunction = lblFunction;        

        function lblFunction(val, max, goal) {
            return Math.round(val) + goal.GoalType.Suffix;
        }
        vm.GetGoalsForUsersInSameUnit = GetGoalsForUsersInSameUnit;

        function GetGoalsForUsersInSameUnit() {
            goalService.GetGoalsForUsersInSameUnit().then(GetDataCallback);

            function GetDataCallback(response) {
                vm.UsersInSameUnit = response.data;
            }
        }

        function GetGoals() {
            goalService.GetGoals(true).then(GetGoalsCallback);  
            
            function GetGoalsCallback(response) {
                var allGoals = response.data;
                vm.Goals = [];
                vm.RootGoals = [];
                
                for(var i = 0; i < allGoals.length; i++) {
                    if(allGoals[i].ParentGoalId > 0) {
                        vm.Goals.push(allGoals[i]);
                    }
                    else {
                        vm.RootGoals.push(allGoals[i]);
                    }
                }
            }
        }

        //function IsExpired(task) {
        //    return !task.IsCompleted && moment(task.DateLocal) < moment();
        //}     

        //function PopulateProgressChart() {
        //    vm.ProgressChartOptions = {
        //        maintainAspectRatio: false,
        //        legend: {
        //            display: true
        //        },
        //        scales: {
        //            yAxes: [{
        //                ticks: {
        //                    beginAtZero: true,
        //                    suggestedMax: 100
        //                }
        //            }]
        //        },
        //        layout: {
        //            padding: {
        //                left: 10
        //            }
        //        }
        //    };
                        
        //    goalService.GetProgressByWeek(vm.UserId, vm.CurrentDate).then(GetProgressByWeekCallback);            

        //    function GetProgressByWeekCallback(response) {
        //        var progressByWeek = BizPartCoreHelpers.getResponseValue(response);                

        //        vm.ProgressChartLabels = [];
        //        vm.ProgressChartData = [];
        //        vm.ProgressChartSeries = [];

        //        var thisWeek = moment().week();
        //        var thisYear = moment().year();
                
        //        var data = [];                
        //        //starting point
        //        vm.ProgressChartLabels.push('');
        //        data.push(0);
        //        for (var i = 0; i < progressByWeek.length; i++) {
        //            vm.ProgressChartLabels.push('v' + progressByWeek[i].Week);
        //            if (progressByWeek[i].Week <= thisWeek && progressByWeek[i].Year <= thisYear) {
        //                data.push(progressByWeek[i].ProgressSumAggregated);                    
        //            }                    
        //        }                

        //        vm.ProgressChartSeries.push('Summering av dina inrapporterade målutfall per vecka.');
        //        vm.ProgressChartData.push(data);   
        //        vm.ThisWeekData = progressByWeek.GetItemByValue('Week', moment().week());                        
        //    }            
        //}

        function LoadTasks() {                       
            goalService.GetTasks(true, vm.PeriodStart, vm.PeriodEnd, vm.UserId).then(GetTasksCallback);
            goalService.GetTasks(false, vm.NextPeriodStart, vm.NextPeriodEnd, vm.UserId).then(GetTasksNextPeriodCallback);

            function GetTasksCallback(response) {                
                vm.TasksInPeriod = BizPartCoreHelpers.getResponseValue(response);
                var completedTasks = 0;
                var notCompletedTasks = 0;
                vm.events = [];

                for (var i = 0; i < vm.TasksInPeriod.length; i++) {
                    var task = vm.TasksInPeriod[i];
                    var color = "#65AEF2";

                    if (vm.TasksInPeriod[i].IsCompleted) {
                        completedTasks++;
                        color = "#3dd452";
                    } else {
                        notCompletedTasks++;
                    }
                    
                    vm.events.push(new event(task.Id, "TASK", task.Text, task.DateLocal, null, color));
                }
                vm.CompletedTasksForUser = completedTasks;
                vm.NotCompletedTasksForUser = notCompletedTasks;
            }   

            function GetTasksNextPeriodCallback(response) {
                vm.TasksInNextPeriod = BizPartCoreHelpers.getResponseValue(response);
            }
        }

        //function GetProgressPeriodCompare() {
        //    goalService.GetProgressSum(true, vm.CurrentDate, vm.PeriodStart, vm.PeriodEnd, vm.PreviousPeriodStart, vm.PreviousPeriodEnd).then(GetProgressForPeriodCompareCallback);

        //    function GetProgressForPeriodCompareCallback(response) {
        //        vm.ProgressForPeriodCompare = BizPartCoreHelpers.getResponseValue(response);                  
        //        vm.UserProgressForPeriodCompare = vm.ProgressForPeriodCompare.GetItemByValue('UserId', vm.UserId);                
        //    }
        //}

        //function GetCurrentProgress() {
        //    goalService.GetProgressSum(true).then(GetProgressSumForUserCallback);

        //    function GetProgressSumForUserCallback(response) {
        //        var unitProgress = BizPartCoreHelpers.getResponseValue(response);                   
        //        vm.CurrentProgressPercent = unitProgress.GetItemByValue('UserId', vm.UserId);

        //        var totalProgressSum = 0;
        //        for (var i = 0; i < unitProgress.length; i++) {
        //            totalProgressSum += unitProgress[i].ProgressValue;
        //        }
        //        vm.TotalProgressSum = unitProgress.length > 0 ? totalProgressSum / unitProgress.length : 0;

        //        var totalProgress = vm.TotalProgressSum;
        //        if (totalProgress > 100) {
        //            totalProgress = 100;
        //        }
        //        vm.data = [Math.round(totalProgress), Math.round(100 - totalProgress)];
        //    }
        //}

        function GetTodoCount() {
            $q.all([
                goalService.GetTodoCountForUsersInSameUnit(vm.PeriodStart, vm.PeriodEnd),
                goalService.GetTodoCountForUsersInSameUnit(vm.PreviousPeriodStart, vm.PreviousPeriodEnd)
            ]).then(GetTodoCountsCallback);

            function GetTodoCountsCallback(result) {
                var inPeriod = BizPartCoreHelpers.getResponseValue(result[0]);
                var prevPeriod = BizPartCoreHelpers.getResponseValue(result[1]);

                vm.TasksCompletedInPeriod = inPeriod.Completed;
                vm.TasksNotCompletedInPeriod = inPeriod.NotCompleted;

                var completedInPreviousPeriod = prevPeriod.Completed;
                var notCompletedInPreviousPeriod = prevPeriod.NotCompleted;                

                vm.TasksCompletedInPreviousPeriod = completedInPreviousPeriod;
                vm.TasksNotCompletedInPreviousPeriod = notCompletedInPreviousPeriod;

                vm.TasksCompletedChange = vm.TasksCompletedInPeriod - completedInPreviousPeriod;
                vm.TaksNotCompletedChange = vm.TasksNotCompletedInPeriod - notCompletedInPreviousPeriod;

                vm.TasksCompletedChangePercent = completedInPreviousPeriod > 0 ? (vm.TasksCompletedChange / completedInPreviousPeriod) * 100 : 0;
                vm.TasksNotCompletedChangePercent = notCompletedInPreviousPeriod > 0 ? (vm.TaksNotCompletedChange / notCompletedInPreviousPeriod) * 100 : 0;
            }
        }   
        
        //function GetUserProgressSum() {
        //    goalService.GetProgressSum(true).then(GetProgressSumCallback);

        //    function GetProgressSumCallback(response) {
                
        //        var progressSum = BizPartCoreHelpers.getResponseValue(response);

        //        if (progressSum.length > 0) {
        //            vm.UserProgressSum = progressSum.GetItemByValue('UserId', vm.UserId);
        //            var progressValue = vm.UserProgressSum.ProgressValue;
        //            if (progressValue > 100) {
        //                progressValue = 100;
        //            }
        //            vm.userData = [Math.round(progressValue), Math.round(100 - progressValue)];
        //        }
        //    }
        //}

        function GetGoalAndActivityComments() {
            goalService.GetGoalAndActivityComments(vm.PeriodStart, vm.PeriodEnd).then(GetGoalAndActivityCommentsCallback);

            function GetGoalAndActivityCommentsCallback(response) {
                vm.GoalAndActivityComments = BizPartCoreHelpers.getResponseValue(response);
            }
        }        
        
        vm.$onInit = function () {      

            goalService.GetMeetingInfo().then(function (response) {
                
                var meetingInfo = BizPartCoreHelpers.getResponseValue(response);

                if (meetingInfo.PeriodType === 1) {
                    var periodEnd = BizPartCoreHelpers.getDateNow();
                    while (periodEnd.isoWeekday() !== meetingInfo.MeetingDay) {
                        periodEnd.add(1, 'days');
                    }

                    vm.PeriodEnd = moment(periodEnd).endOf('day');
                    vm.PeriodStart = moment(vm.PeriodEnd).add(-6, 'days').startOf('day');

                    vm.PreviousPeriodEnd = moment(vm.PeriodStart).add(-1, 'days').endOf('day');
                    vm.PreviousPeriodStart = moment(vm.PreviousPeriodEnd).add(-6, 'days').startOf('day');

                    vm.NextPeriodStart = moment(vm.PeriodEnd).add(1, 'days').startOf('day');
                    vm.NextPeriodEnd = moment(vm.NextPeriodStart).add(6, 'days').endOf('day');
                } else {

                    if (!meetingInfo.CurrentMeeting) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Inget möte finns inlagt. Kontakta din teamleader.')
                                .position('bottom right')
                        );
                    } else {
                        
                        vm.PeriodStart = moment(meetingInfo.CurrentMeeting.PeriodStart);                        
                        vm.PeriodEnd = moment(meetingInfo.CurrentMeeting.PeriodEnd);

                        if (meetingInfo.PreviousMeeting && meetingInfo.PreviousMeeting.PeriodEnd) {
                            vm.PreviousPeriodEnd = moment(meetingInfo.PreviousMeeting.PeriodEnd);
                        } else {
                            vm.PreviousPeriodEnd = moment(vm.PeriodStart).add(-1, 'days').endOf('day');
                        }

                        if (meetingInfo.PreviousMeeting && meetingInfo.PreviousMeeting.PeriodStart) {
                            vm.PreviousPeriodStart = moment(meetingInfo.PreviousMeeting.PeriodStart);
                        } else {
                            vm.PreviousPeriodStart = moment(vm.PreviousPeriodEnd).add(-30, 'days').startOf('day');
                        }

                        if (meetingInfo.NextMeeting && meetingInfo.NextMeeting.PeriodStart) {
                            vm.NextPeriodStart = moment(meetingInfo.NextMeeting.PeriodStart);
                        } else {
                            vm.NextPeriodStart = moment(vm.PeriodEnd).add(1, 'days').startOf('day');
                        }

                        if (meetingInfo.NextMeeting && meetingInfo.NextMeeting.PeriodEnd) {
                            vm.NextPeriodEnd = moment(meetingInfo.NextMeeting.PeriodEnd);
                        } else {
                            vm.NextPeriodEnd = moment(vm.NextPeriodStart).add(30, 'days').endOf('day');
                        }
                        
                        
                    }
                }

                vm.LoadTasks();
                vm.GetTodoCount();                                            
                vm.GetGoalAndActivityComments();                
            });

            //vm.GetCurrentProgress();
            //vm.GetUserProgressSum();
            vm.GetGoals();
            vm.GetGoalsForUsersInSameUnit();
            
            //vm.GetProgressPeriodCompare();
            //vm.PopulateProgressChart();            
        }
    }

})(window.angular);
